import api, { getPropertyAnalytics } from '../utils/api';
import { GET_PROPERTY_DETAILS } from '../constants/requests';

export function getPropertyDetailsRequest() {
  return {
    type: GET_PROPERTY_DETAILS.REQUEST,
  };
}

export function getPropertyDetailsReceive(propertyDetails, propertyAnalytics) {
  return {
    type: GET_PROPERTY_DETAILS.RECEIVE,
    propertyDetails,
    propertyAnalytics,
  };
}

export function getPropertyDetailsFailure(error) {
  return {
    type: GET_PROPERTY_DETAILS.FAILURE,
    error,
  };
}

export function getPropertyDetails(propertyId) {
  return (dispatch) => {
    dispatch(getPropertyDetailsRequest());
    return Promise.all([
      dispatch(api.user.properties.details({ propertyId })),
      dispatch(getPropertyAnalytics({ propertyId })),
    ])
      .then(([propertyDetailsResponse, propertyAnalyticsResponse]) => {
        return dispatch(
          getPropertyDetailsReceive(propertyDetailsResponse?.data?.response, propertyAnalyticsResponse?.data?.response),
        );
      })
      .catch((error) => {
        return dispatch(getPropertyDetailsFailure(error));
      });
  };
}
